import { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    const previousTitle = `${document.title}`;
    document.title = `${title} | Sky Postal`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export default useTitle;
